import React from 'react';
import { Card, Divider } from 'antd';
import OptionTag from './../OptionTag';
import { buildOptions, buildAnswerVariants } from './../../utils/survey';
import ResultTotalAnswers from './../ResultTotalAnswers';
import ResultTitle from './../ResultTitle';
import ResultAnswerCard from './../ResultAnswerCard';

const ResultSimple = ({ id, stepAnswers, questions, answers }) => {
	const answerValues = Object.values(stepAnswers);
	const totalAnswers = answerValues.length;
	const question = questions[id];
	const answerVariants = buildAnswerVariants(answerValues);
	const options = buildOptions(answerValues);
	const answerCardProps = { answerVariants, totalAnswers, answers, question };
	
	return (
		<Card className='Result'>
			<div className='Answer'>
				<ResultTitle questions={questions} id={id}/>
				<ResultTotalAnswers stepAnswers={stepAnswers}/>
			</div>
			<Divider/>
			<div className='Answer'>
				<ResultAnswerCard {...answerCardProps}/>
				<OptionTag options={options}/>
			</div>
		</Card>
	);
};

export default ResultSimple;


// WEBPACK FOOTER //
// ./src/components/ResultSimple/ResultSimple.js